import React, { useContext } from 'react';
import moment from 'moment';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import { makeStyles } from '@material-ui/core/styles';
import { CalendarEditAvailabilityContext } from '../../Context';

const useStyles = makeStyles(() => ({
  tableContainer: {
    maxHeight: '300px',
    minWidth: '275px',
    marginBottom: '20px',
  },
  cursorPointer: {
    cursor: 'pointer',
  },
  selectedDay: {
    cursor: 'pointer',
    background: '#296690',
    color: '#FFFFFF',
  },
}));

const ExceptionsTable = () => {
  const { scheduleExceptions, handleSelectDate, selectedDate } = useContext(
    CalendarEditAvailabilityContext,
  );
  const classes = useStyles();

  return (
    <TableContainer className={classes.tableContainer}>
      <Table stickyHeader>
        <TableHead>
          {scheduleExceptions.length > 0 && (
            <TableRow>
              <TableCell>Exception</TableCell>
              <TableCell>Time Range</TableCell>
            </TableRow>
          )}
        </TableHead>
        <TableBody>
          {scheduleExceptions.map((exception) => (
            <TableRow key={exception.id}>
              <TableCell
                component="th"
                scope="row"
                className={
                  moment(selectedDate).format('MM/DD/YYYY') ===
                  moment(exception.start_time).format('MM/DD/YYYY')
                    ? classes.selectedDay
                    : classes.cursorPointer
                }
                onClick={() => {
                  handleSelectDate(exception.start_time);
                }}
              >
                {moment(exception.start_time).format('MM/DD/YYYY')}
              </TableCell>
              <TableCell>
                {exception.is_canceled
                  ? 'Unavailable'
                  : `${moment(exception.start_time).format(
                      'h:mm a',
                    )} - ${moment(exception.end_time).format('h:mm a')}`}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ExceptionsTable;
